import React, {useEffect, useState} from 'react';
import {message} from 'antd';
import Advert from '~/component/Advert';
import Overview from '~/component/Overview';
import Upcoming from '~/component/Upcoming';
import PastEvents from '~/component/PastEvents';
import RecentNews from '~/component/RecentNews';
import Contact from '~/component/Contact';
import {getByChannelCode, getRecentNews} from '~/service/cms';
import {haboView} from '~/utils/tracking/habo';
import {PageViewEventsId} from '~/utils/tracking/eventsId';
import {getStockInfo} from '~/service/stock';

import './index.less';

const codeList = [
    // 概述
    'channel_ir_gs',
    // 事件
    'channel_ir_events',
    // 过去的
    'ir_past_events'
];

function Home() {
    const [stockInfo, setStockInfo] = useState({});
    const [channelIrGs, setChannelIrGs] = useState({});
    const [channelIrEvents, setChannelIrEvents] = useState({contentResponseList: []});
    const [channelPastEvents, setChannelPastEvents] = useState({});
    const [recentNews, setRecentNews] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        haboView(PageViewEventsId.HOME);
        getStockInfo({})
            .then(({data}) => {
                setStockInfo(data);
            })
            .catch(() => {
                message.error('获取股票信息失败');
            });
        getByChannelCode({codeList})
            .then(({data}) => {
                const {channel_ir_gs, channel_ir_events, ir_past_events} = data;
                setChannelIrGs(channel_ir_gs);
                setChannelIrEvents(channel_ir_events);
                setChannelPastEvents(ir_past_events);
            })
            .catch(() => {
                message.error('获取首页信息失败');
            });
        getRecentNews({pageDto: {pageNum: 1, pageSize: 10}})
            .then(({data: {list}}) => {
                setRecentNews(list);
            })
            .catch(() => {
                message.error('获取首页新闻信息失败');
            });

    }, []);

    return (
        <div className="home-content">
            <div className="event-bg">
                <Advert stockInfo={stockInfo} />
                <Overview channelIrGs={channelIrGs} />
                {
                    channelIrEvents && channelIrEvents.contentResponseList.length > 0 && (

                        /* @ts-ignore */
                        <Upcoming data={channelIrEvents} />
                    )
                }
                {/* @ts-ignore */}
                <PastEvents data={channelPastEvents} />
                {/* @ts-ignore */}
                <RecentNews data={recentNews} />
            </div>
            <Contact />
        </div>
    );
}

export default Home;
